/**
 * Legenda do radar: uma linha por faixa de leitura ("chuva fraca",
 * "moderada"…), com as cores EXATAS de cada classe da legenda oficial e a
 * faixa de valores. Usada no painel e na legenda sobre o mapa.
 */
import clsx from 'clsx';
import { DEF_PRODUTO, rotuloClasse, type Produto } from './produtos';

const fmt = (n: number) => String(n).replace('-', '−');

export function LegendaRadar(props: { produto: Produto; compacta?: boolean }) {
  const def = DEF_PRODUTO[props.produto];
  return (
    <ul className={clsx('space-y-1', props.compacta ? 'text-[11px]' : 'text-xs')} aria-label={`Legenda: ${def.titulo}`}>
      {def.leituras.map((l) => {
        const classes = def.classes.slice(l.de, l.ate + 1);
        return (
          <li key={l.texto} className="flex items-center gap-2">
            <span className="flex shrink-0 overflow-hidden rounded-[3px] ring-1 ring-white/25" aria-hidden>
              {classes.map((k, j) => (
                <span
                  key={k.cor}
                  className="inline-block h-3 w-2.5"
                  style={{ background: k.cor }}
                  title={rotuloClasse(def, l.de + j)}
                />
              ))}
            </span>
            <span className="min-w-0 flex-1 text-ink-100">{l.texto}</span>
            <span className="shrink-0 text-ink-300 tabular-nums">
              {fmt(classes[0].min)} a {fmt(classes[classes.length - 1].max)}
              {!props.compacta && ` ${def.unidade}`}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
